// DstackResultViewer.tsx
import React, { forwardRef } from 'react';
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';
import './Dstack2.css';

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- 
//  DStackTopLevel - top level object

/*
const InfoContainer = styled.div`
  padding: 4px;
  text-align: center;
  color: var(--text-color);
  font-size: 0.8rem;
`;

// background-color: var(--background-color);

const TopLevelInfo = ({ steps }: { steps: string[] }) => {
  return (
    <InfoContainer>
      {steps.join(' ')}
    </InfoContainer>
  );
};
*/

interface ResultViewerProps {
  result: string;
  isLoading: boolean;
  error: string | null;
}

const ResultContainer = styled.div`
  font-family: monospace;
  white-space: pre-wrap;
  overflow-y: auto;
`;
//   flex: 1;
const DstackResultViewer = forwardRef<HTMLDivElement, ResultViewerProps>(
  ({ result, isLoading, error}, ref) => {
    return (
      <div className="dstack-output output-wrapper">
        <h2 className="text-xl font-semibold">Dstack Analysis</h2>
        
        {/* Optionally display a more prominent error message */}
        {/* Error Display */}
        {error && (
            <div className="bg-red-800 text-white p-3 rounded mb-4">
            <strong>Error:</strong> {error}
            </div>
        )}

        <ResultContainer ref={ref} className='results-container'>
            <ReactMarkdown>{result || (isLoading ? '_Loading..._' : '_Output will appear here._')}</ReactMarkdown>
        </ResultContainer>
            {/* <div className="output-content bg-gray-900 p-4 rounded border border-gray-700">
            </div> */}
      </div>

    );
  }
);

DstackResultViewer.displayName = 'DstackResultViewer'; // Recommended for forwardRef

export default DstackResultViewer;